import { tableAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle, } from '@chakra-ui/styled-system';
import { ThemeColorVariable, ThemeFontVariable, ThemeSpaceVariable, } from '../../theme-types';
import { ThemeFontSizeToken } from '../theme-tokens';
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tableAnatomy.keys);
const baseTableStyle = defineStyle({
    position: 'relative',
    fontFamily: ThemeFontVariable.Body,
    fontSize: ThemeFontSizeToken.Small,
    th: {
        padding: '0px',
        position: 'relative',
        fontSize: ThemeFontSizeToken.Small,
        height: '40px',
        color: ThemeColorVariable.OnBackgroundSubdued,
        fontWeight: 400,
        textTransform: 'none',
        div: {
            _hover: {
                backgroundColor: ThemeColorVariable.BackgroundDisabled,
            },
        },
    },
    td: {
        color: ThemeColorVariable.OnBackground,
        padding: `0px 0px 0px ${ThemeSpaceVariable.Small}`,
        borderRight: `1px solid ${ThemeColorVariable.OnBackgroundBorder}`,
        height: '40px',
        gap: ThemeSpaceVariable.XSmall,
        _last: {
            borderRight: 'none',
        },
    },
    tr: {
        borderColor: ThemeColorVariable.OnBackgroundBorder,
    },
});
const baseTableHeaderCellStyle = defineStyle({
    cursor: 'pointer',
    backgroundColor: ThemeColorVariable.Surface,
    div: {
        span: {
            color: ThemeColorVariable.OnBackgroundSubdued,
            fontWeight: 400,
        },
    },
});
const baseTableFooterStyle = defineStyle({
    color: ThemeColorVariable.OnBackground,
});
const baseTableRowStyle = defineStyle({
    borderTop: '1px solid',
    _first: {
        borderTop: 'none',
    },
    _last: {
        borderBottom: '1px solid',
        borderColor: ThemeColorVariable.OnBackgroundBorder,
    },
});
const baseTableHeaderStyle = defineStyle({
    tr: {
        zIndex: 10,
        backgroundColor: ThemeColorVariable.OnBackgroundSubdued,
    },
});
const baseStyle = definePartsStyle({
    table: baseTableStyle,
    tfoot: baseTableFooterStyle,
    th: baseTableHeaderCellStyle,
    tr: baseTableRowStyle,
    thead: baseTableHeaderStyle,
});
export const tableConfig = defineMultiStyleConfig({
    baseStyle,
});
//# sourceMappingURL=table-theme.js.map